document.addEventListener('DOMContentLoaded', function () {

  // ── DROPDOWN NAV ──
  // Strategy: use a generous 350ms close delay so moving mouse between
  // trigger and dropdown never accidentally closes it. Cancel on re-enter.
  var timers = {};

  document.querySelectorAll('.nav-item--dropdown').forEach(function (item, idx) {
    var dropdown = item.querySelector(':scope > .nav-dropdown');
    if (!dropdown) return;

    function openDrop() {
      clearTimeout(timers['d' + idx]);
      dropdown.classList.add('open');
    }
    function scheduleDrop() {
      timers['d' + idx] = setTimeout(function () {
        dropdown.classList.remove('open');
      }, 350);
    }

    // Both the trigger item AND the dropdown keep it open on hover
    item.addEventListener('mouseenter', openDrop);
    item.addEventListener('mouseleave', scheduleDrop);
    dropdown.addEventListener('mouseenter', function () { clearTimeout(timers['d' + idx]); });
    dropdown.addEventListener('mouseleave', scheduleDrop);

    // Click toggle for account button (touch-friendly)
    var toggle = item.querySelector(':scope > .account-toggle');
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dropdown.classList.contains('open');
        // Close all others first
        document.querySelectorAll('.nav-dropdown.open').forEach(function (d) { d.classList.remove('open'); });
        if (!isOpen) dropdown.classList.add('open');
      });
    }

    // Sub-subdropdowns (3rd level) — same pattern
    item.querySelectorAll('.nav-dropdown-item--has-sub').forEach(function (sub, si) {
      var subKey = 's' + idx + '_' + si;
      var subDrop = sub.querySelector('.nav-subdropdown');
      if (!subDrop) return;

      sub.addEventListener('mouseenter', function () {
        clearTimeout(timers[subKey]);
        subDrop.style.display = 'block';
      });
      sub.addEventListener('mouseleave', function () {
        timers[subKey] = setTimeout(function () { subDrop.style.display = 'none'; }, 300);
      });
      subDrop.addEventListener('mouseenter', function () { clearTimeout(timers[subKey]); });
      subDrop.addEventListener('mouseleave', function () {
        timers[subKey] = setTimeout(function () { subDrop.style.display = 'none'; }, 300);
      });
    });
  });

  // Close all dropdowns when clicking anywhere outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item--dropdown')) {
      document.querySelectorAll('.nav-dropdown.open').forEach(function (d) { d.classList.remove('open'); });
    }
  });

  // ── MOBILE NAV TOGGLE ──
  var toggle = document.getElementById('mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      mobileNav.classList.toggle('open');
    });
  }

  // ── PRODUCT CAROUSEL ──
  var track = document.getElementById('carousel-track');
  var dotsContainer = document.getElementById('carousel-dots');
  var prevBtn = document.getElementById('carousel-prev');
  var nextBtn = document.getElementById('carousel-next');

  if (track && dotsContainer) {
    var cards = track.querySelectorAll('.product-card');
    if (!cards.length) return;

    function getPerPage() {
      return window.innerWidth < 600 ? 1 : window.innerWidth < 900 ? 2 : 3;
    }

    var perPage = getPerPage();
    var totalDots = Math.ceil(cards.length / perPage);
    var current = 0;

    for (var i = 0; i < totalDots; i++) {
      var d = document.createElement('div');
      d.className = 'dot' + (i === 0 ? ' active' : '');
      d.setAttribute('data-index', i);
      d.addEventListener('click', function () { goTo(parseInt(this.getAttribute('data-index'))); });
      dotsContainer.appendChild(d);
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, totalDots - 1));
      var cardWidth = cards[0].offsetWidth + 14;
      track.scrollTo({ left: current * perPage * cardWidth, behavior: 'smooth' });
      dotsContainer.querySelectorAll('.dot').forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    });
  }

});
